var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _circle, _circle2, _circle3, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _rect2, _path36, _polygon, _path37, _polygon2, _path38, _circle4, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManHello(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "10 68.2 979.3 424.8",
    style: {
      enableBackground: "new 10 68.2 979.3 424.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#CCCCCC;}\r\n\t.st1{fill:#F2F2F2;}\r\n\t.st2{fill:#4299E1;}\r\n\t.st3{fill:#3F3D56;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#E6E6E6;}\r\n\t.st6{fill:#FFB6B6;}\r\n\t.st7{fill:#E4E4E4;}\r\n\t.st8{fill:#2F2E41;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M893.4,243.4H318.8c-5.1,0-9.2,4.1-9.2,9.2s4.1,9.2,9.2,9.2h16.3v220.1c0,5.1,4.1,9.2,9.2,9.2s9.2-4.1,9.2-9.2 l0.1-220.1h461.2l42.5,220.1c0,5.1,4.1,9.2,9.2,9.2c5.1,0,9.2-4.1,9.2-9.2l2.7-220.1h15c5.1,0,9.2-4.1,9.2-9.2 S898.5,243.4,893.4,243.4L893.4,243.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.4,202.4v39h-97.6c-10.8,0.4-19.8-8-20.2-18.8c-0.4-10.8,8-19.8,18.8-20.2c0.5,0,0.9,0,1.4,0L418.4,202.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M420.8,241.1c0,0.8-0.7,1.5-1.5,1.5H319.1c-11.3,0-20.5-9.2-20.5-20.5c0-11.3,9.2-20.5,20.5-20.5h100.2 c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5c0,0,0,0,0,0H319.1c-9.7,0-17.5,7.9-17.5,17.6c0,9.7,7.8,17.5,17.5,17.5h100.2 C420.1,239.6,420.8,240.3,420.8,241.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.4,211.4H313.5c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3l0,0h104.9c0.2,0,0.3,0.1,0.3,0.3 C418.7,211.3,418.6,211.4,418.4,211.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.4,218.6H313.5c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3l0,0h104.9c0.2,0,0.3,0.1,0.3,0.3 C418.7,218.5,418.6,218.6,418.4,218.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.4,225.8H313.5c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3l0,0h104.9c0.2,0,0.3,0.1,0.3,0.3 C418.7,225.7,418.6,225.8,418.4,225.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.4,233H313.5c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h104.9c0.2,0,0.3,0.1,0.3,0.3 C418.7,232.9,418.6,233,418.4,233z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400,161.4v39h-97.6c-10.8,0.4-19.8-8-20.2-18.8c-0.4-10.8,8-19.8,18.8-20.2c0.5,0,0.9,0,1.4,0H400z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M402.4,200c0,0.8-0.7,1.5-1.5,1.5H300.7c-11.3,0-20.5-9.2-20.5-20.5c0-11.3,9.2-20.5,20.5-20.5h100.2 c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5H300.7c-9.7,0-17.5,7.9-17.5,17.5c0,9.7,7.8,17.5,17.5,17.5h100.2 C401.7,198.5,402.4,199.2,402.4,200z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400,170.4H295.1c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3l0,0H400c0.2,0,0.3,0.1,0.3,0.3 C400.3,170.2,400.2,170.4,400,170.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400,177.6H295.1c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3l0,0H400c0.2,0,0.3,0.1,0.3,0.3 C400.3,177.4,400.2,177.6,400,177.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400,184.8H295.1c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3l0,0H400c0.2,0,0.3,0.1,0.3,0.3 C400.3,184.6,400.2,184.8,400,184.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400,192H295.1c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3l0,0H400c0.2,0,0.3,0.1,0.3,0.3 C400.3,191.8,400.2,192,400,192z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M513.5,381.3v-34c0-3.1-2.5-5.7-5.7-5.7H379.1c-3.1,0-5.7,2.5-5.7,5.7v34H513.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 373.4,
    y: 394,
    className: "st0",
    width: 140.1,
    height: 43.9
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.4,450.6v34c0,3.1,2.5,5.7,5.7,5.7h128.8c3.1,0,5.7-2.5,5.7-5.7v-34H373.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 442.8,
    cy: 362.9,
    r: 4.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 442.8,
    cy: 419.5,
    r: 4.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 443,
    cy: 474.9,
    r: 4.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.7,302.9v39h-97.6c-10.8,0.4-19.8-8-20.2-18.8c-0.4-10.8,8-19.8,18.8-20.2c0.5,0,0.9,0,1.4,0H497.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M500,341.6c0,0.8-0.7,1.5-1.5,1.5H398.3c-11.3,0-20.5-9.2-20.5-20.5c0-11.3,9.2-20.5,20.5-20.5l0,0h100.3 c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5c0,0,0,0,0,0H398.3c-9.7,0-17.5,7.9-17.5,17.6c0,9.7,7.8,17.5,17.5,17.5h100.2 C499.4,340.1,500,340.7,500,341.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.7,311.9H392.8c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3l0,0h104.9c0.2,0,0.3,0.1,0.3,0.3 C497.9,311.8,497.8,311.9,497.7,311.9L497.7,311.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.7,319.1H392.8c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3l0,0h104.9c0.2,0,0.3,0.1,0.3,0.3 C497.9,319,497.8,319.1,497.7,319.1L497.7,319.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.7,326.3H392.8c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h104.9c0.2,0,0.3,0.1,0.3,0.3 C497.9,326.2,497.8,326.3,497.7,326.3L497.7,326.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.7,333.5H392.8c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3l0,0h104.9c0.2,0,0.3,0.1,0.3,0.3 C497.9,333.3,497.8,333.5,497.7,333.5L497.7,333.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M383,148.4h-44.5c-0.4,0-0.8,0.1-1.2,0.3l-11.2,5.6c-1,0.4-1.5,1.6-1.1,2.7c0.2,0.5,0.6,0.9,1.1,1.1l11.2,5.6 c0.4,0.2,0.8,0.3,1.2,0.3H383c1.3,0.1,2.4-0.9,2.5-2.2v-11.2C385.4,149.3,384.3,148.3,383,148.4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M385.5,150.6v11.2c-0.1,1.3-1.2,2.2-2.5,2.2h-8.9v-15.6h8.9C384.3,148.3,385.4,149.3,385.5,150.6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M116.4,368.6c11.6,4.1,24.6,1.8,34.1-6c12-10,15.7-26.6,18.7-41.9c3-15.1,6-30.2,9-45.3l-18.9,13 c-13.6,9.3-27.5,19-36.9,32.5s-13.5,32-6,46.7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.1,423.4c-1.9-13.9-3.9-28-2.5-42.1c1.2-12.5,5-24.7,12.8-34.7c4.1-5.3,9.1-9.8,14.8-13.4 c1.5-0.9,2.8,1.4,1.4,2.3c-9.8,6.2-17.4,15.4-21.7,26.2c-4.7,12-5.5,25.1-4.7,37.9c0.5,7.7,1.5,15.4,2.6,23.1 c0.2,0.7-0.2,1.4-0.9,1.7C119,424.5,118.3,424.1,118.1,423.4L118.1,423.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M136.5,398.7c5,7.6,13.6,12,22.7,11.7c11.5-0.5,21-8.6,29.7-16.2l25.5-22.5l-16.9-0.8 c-12.1-0.6-24.6-1.1-36.1,2.6s-22.2,12.7-24.3,24.7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.7,431.4c9.2-16.3,19.9-34.4,38.9-40.1c5.3-1.6,10.9-2.2,16.4-1.7c1.7,0.1,1.3,2.8-0.4,2.7 c-9.2-0.8-18.5,1.7-26.1,6.9c-7.4,5-13.1,12-18,19.4c-3,4.5-5.6,9.3-8.3,14C114.3,434,111.8,432.9,112.7,431.4L112.7,431.4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.9,448.5c0.6-7.3,5.3-13.7,12.1-16.5v-9.4h15.8v9.7c6.4,3,10.8,9.1,11.4,16.2l3.7,43.1H94.2L97.9,448.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M634.6,242.5l-4.7-2l-3.2-23.5h-42.9l-3.5,23.4l-4.2,2.1c-0.5,0.2-0.7,0.8-0.4,1.3c0.2,0.3,0.5,0.6,0.9,0.6 h57.7c0.6,0,1-0.4,1-1C635.2,243.1,635,242.7,634.6,242.5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M710.9,220.2H500.2c-2.3,0-4.2-1.9-4.2-4.2v-29.7h219V216C715,218.3,713.2,220.2,710.9,220.2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M715.2,200.3H495.8V73.2c0-2.8,2.3-5,5-5h209.4c2.8,0,5,2.3,5,5L715.2,200.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M702.1,191.1H508.9c-2.1,0-3.9-1.7-3.9-3.9V81.3c0-2.1,1.7-3.9,3.9-3.9h193.2c2.1,0,3.9,1.7,3.9,3.9v105.9 C706,189.3,704.3,191.1,702.1,191.1z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M651.2,228.5c4.7-4.4,12.1-4.1,16.4,0.7c0.5,0.5,0.9,1,1.3,1.6l26.1-4.6l6.7,15.2l-37,6 c-5.7,3.1-12.8,1-15.9-4.6C646.3,238,647.3,232.1,651.2,228.5z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M675.4,247.9l27.2-0.3l3.4,0l55.4-0.7c0,0,15.1-14.4,28.2-29.1l-1.8-13.3c-1.8-13-8.3-25-18.2-33.6 c-18.8,12.5-29.7,37.4-29.7,37.4l-34.4,8.2l-3.4,0.8l-21.4,5.1L675.4,247.9z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M814.9,329.5h-50.9c0,2.2-55.6,3.9-55.6,3.9c-1.2,0.9-2.3,2-3.3,3.2c-3,3.5-4.6,8-4.6,12.6v3.2 c0,10.9,8.8,19.7,19.7,19.7h94.6c10.9,0,19.7-8.8,19.7-19.7v-3.2C834.6,338.4,825.8,329.6,814.9,329.5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 757.4,
    y: 371.4,
    className: "st7",
    width: 20.5,
    height: 118.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M699,489.2c0,2.2,31.1,0.9,69.5,0.9s69.5,1.4,69.5-0.9s-31.1-19.8-69.5-19.8S699,486.9,699,489.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "685.2,475.6 669.9,475.6 662.6,416.7 685.2,416.7 "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M689.1,490.4l-49.3,0v-0.6c0-10.6,8.6-19.2,19.2-19.2h0l30.1,0L689.1,490.4z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "640,475.6 624.8,475.6 617.5,416.7 640,416.7 "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M643.9,490.4l-49.3,0v-0.6c0-10.6,8.6-19.2,19.2-19.2h0l30.1,0L643.9,490.4z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 776.9,
    cy: 109.8,
    r: 26.6
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M819.9,291.8c0,0,8.9,47.1-25,53.1c-33.9,6-82.9,10.2-82.9,10.2l-22,102.6l-29.5-2.6c0,0,3.9-123.5,13.6-133.1 s70.7-38.6,70.7-38.6L819.9,291.8z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M753.6,272.1l-14.8,14.9c0,0-107.1,17.3-111.2,42c-6.2,37.3-13.6,118.6-13.6,118.6l32.2-2.4l12.6-92.3 l51.5-11.7l58.6-31.9L753.6,272.1z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M802.4,93.9c-2.6-4.9-6-14.8-11.2-16.6c-2.9-1-6-1.6-9.1-1.9l-9,3.5L778,75c-1-0.1-1.9-0.1-2.9-0.1l-6.1,2.3 l3.1-2.4c-5.7-0.1-11.5,0.5-15.9,4c-3.7,2.9-7.4,14.1-8,18.8c-0.6,4.5-0.4,9.1,0.7,13.5l1.5,1.5c0.5-1.2,0.9-2.5,1.2-3.8 c1.1-5,4.3-9.3,8.7-11.8l0.1,0c2.6-1.5,5.7-1.4,8.7-1.3l14,0.5c3.4,0.1,7,0.3,9.6,2.5c1.7,1.6,3,3.5,3.9,5.6 c1.3,2.6,3.9,12.6,3.9,12.6s1.4-1.9,2.1-0.5c1.1-3.7,1.8-7.4,2-11.2C804.9,101.2,804.2,97.4,802.4,93.9z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M895.4,121.5c-6.4,0.4-11.2,6-10.8,12.4c0,0.7,0.2,1.4,0.3,2l-21.4,15.8l6.4,15.3l29.9-22.7 c6.1-2,9.5-8.5,7.6-14.7C905.7,124.4,900.7,121.1,895.4,121.5L895.4,121.5z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M891.9,153.6l-53.6,59.5c0,0-25.6-8.2-45.4-17.1l-8.9-27.3c-2.1-6.3-2.9-13-2.6-19.7 c27.5-7.3,59.4,19.9,59.4,19.9l40.1-31.4L891.9,153.6z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M767,296.2c-9.6-3.3-19.4-6.7-30.1-8l-0.5-0.1l0.1-0.4c11-38.7,8.3-63.5,2.9-100.7 c-2.4-16.5,6.4-32.6,21.5-39.5l0.1,0l30.4-1.9l0.1,0l22.1,6.5c6.5,1.9,11,8,10.9,14.8c-0.2,12.2,0.3,25.9,0.8,40.4 c1.2,32.5,2.5,66-4.6,87.8l0,0.1l-0.1,0.1c-6.5,5.3-14.7,8.2-23.1,8.1C787.6,303.3,777.4,299.8,767,296.2z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M987.9,493H11.4c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4h976.5c0.8,0,1.4,0.6,1.4,1.4S988.7,493,987.9,493z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHello);
export default __webpack_public_path__ + "static/media/man_hello.65bd4bade1d0c2eb3c79c0559c60e856.svg";
export { ForwardRef as ReactComponent };